import React, { useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { logLoginEvent } from '../../services/auditTrail-service';

const SessionKickedModal = ({ show, onLogin }) => {
  useEffect(() => {
    if (show) {
      const userData = JSON.parse(sessionStorage.getItem('userData') || '{}');
      logLoginEvent({
        userId: userData.userId || '',
        action: 'SESSION_KICKED',
        sessionId: sessionStorage.getItem('SessionId') || '',
        reason: 'kicked',
        status: 'success'
      });
    }
  }, [show]);

  return (
    <Modal 
      show={show} 
      backdrop="static" 
      keyboard={false}
      centered
      size="md"
    >
      <Modal.Header style={{ borderBottom: '2px solid #810055' }}>
        <Modal.Title style={{ fontFamily: "'G&B-Headline', sans-serif", color: '#810055' }}>
          Session Ended
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: '1.5rem' }}>
        <div style={{
          backgroundColor: '#F9F2F6',
          border: '1px solid #810055',
          borderRadius: '6px',
          padding: '1rem 1.25rem',
          color: '#810055',
          fontFamily: "'G&B-BodyCopy', sans-serif",
          fontSize: '0.95rem',
          lineHeight: '1.5'
        }}>
          Your session has been taken over by another device. 
          You have been logged out for security reasons.
        </div>
        <p style={{ 
          marginTop: '1rem', 
          color: '#707070', 
          fontSize: '0.85rem',
          fontFamily: "'G&B-BodyCopy', sans-serif"
        }}>
          If this was not you, please contact your system administrator immediately.
        </p>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: '1px solid #F1F1ED' }}>
        <Button variant="primary" onClick={onLogin}>
          Login Again
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SessionKickedModal;
